import React, {
  FC,
} from 'react';
import {
  ColumnCenter,
} from '../../Styles';
import { getWindowWidth, isMobile } from '../../../../../../../lib/utils/utils';
import InterMediumText from '../../../../../../../components/Text/InterMediumText';
import InterBoldText from '../../../../../../../components/Text/InterBoldText';
import PingFangMediumText from '../../../../../../../components/Text/PingFangMediumText';
import Input from '../../../../../../../components/Input';
import { Building3pdVO } from '../../../../../../../lib/types';

const RoomNo: FC<Props> = ({
  isEnglish,
  formError,
  roomNo,
  setRoomNo,
  buildingList,
}) => {
  const inputWidth = isMobile() ? getWindowWidth() - 40 : 400;
  return (
    <div style={{ marginTop: 30 }}>
      <div style={{ width: isMobile() ? getWindowWidth() - 40 : 400, marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
        {
          isEnglish ? (
            <InterMediumText fontSize={16} lineHeight={22}>
              Unit/Apartment number<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
            </InterMediumText>
          ) : (
            <PingFangMediumText fontSize={16} color={'#000000'}>
              门牌号<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
            </PingFangMediumText>
          )
        }
      </div>

      {/* 名字输入框 */}
      <ColumnCenter style={{ height: 60, width: inputWidth, marginLeft: 'auto', marginRight: 'auto', alignItems: 'center', backgroundColor: 'rgba(228, 228, 228, 0.5)', borderRadius: 5, marginTop: 10, border: formError && !roomNo ? '1px solid #F44336' : 'none' }}>
        {
          <Input
            style={{
              border: 'none',
              outline: 'none',
              fontSize: '18px',
              fontFamily: 'Inter-Regular, Inter',
              fontWeight: 400,
              color: '#000000',
              backgroundColor: 'transparent',
              lineHeight: '35px',
              width: inputWidth - 20,
              textAlign: 'center',
            }}
            autoFocus={!buildingList} // 如果有建筑选择，则不能设置自动聚焦
            placeholder={'3011'}
            placeFontFamily={'Inter-Regular, Inter'}
            placeholderColor={'rgba(0, 0, 0, 0.5)'}
            value={roomNo}
            onChange={(e) => {
              setRoomNo(e.target.value);
            }}
          />
        }
      </ColumnCenter>
    </div>
  );
};

export interface Props {
  isEnglish: boolean;
  formError: boolean;
  roomNo?: string;
  setRoomNo: (email: string) => void;
  buildingList?: Building3pdVO[];
}

export default RoomNo;
